export default __webpack_public_path__ + "static/media/hero-bcg-2.78991864.jpeg";